var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('FormBuilder',{attrs:{"label":"Brand","create":"","fields":_vm.fields,"loading-submit":_vm.$store.state.brand.loadingSubmit},on:{"submit":_vm.submitData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }